var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#26E5E9",
    clipRule: "evenodd",
    d: "M10.164 2A2.49 2.49 0 008.12 3.087L6.75 5.125H4.187C3.497 5.125 3 5.673 3 6.313 3 6.997 3.503 7.5 4.188 7.5h.197l.92 12.464v.003c.13 1.456 1.29 2.533 2.75 2.533h7.851c1.46 0 2.62-1.077 2.75-2.533l.92-12.467h.236c.64 0 1.188-.496 1.188-1.188a1.2 1.2 0 00-1.188-1.187h-2.6L15.84 3.087A2.49 2.49 0 0013.796 2h-3.633zm-.057 2.408l.004-.008a.108.108 0 01.04-.022.05.05 0 01.013-.003h3.633a.108.108 0 01.053.025l.004.008.487.717H9.62l.486-.717zM7.678 19.802L6.762 7.5h10.437l-.917 12.302a.382.382 0 01-.376.323H8.055a.382.382 0 01-.377-.323z"
  })));
};
export default SvgTrash;